module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAALCAYAAACtWacbAAAAhUlEQVQoU33PMQoCMRCF4f+/hJ2Hc22stBMbbS33DIIX0EvoDfQGioWtlYwENhBC3HRDvveGMSIm6ouRZ0TsgSmwVN8tm9EGeAIL9VTDEuW/I7AqW1so4cfQek7DP5RbD8B8DN2BmXptoS/QAzv101qX0p16KS/MTeshvc3pGnXArU6X6AcWrT4MFbll4gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/go@2x.png
// module id = /yxA
// module chunks = 69